// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Reduce opacity of all placeholders so they are clearly distinguishable from entered values.
 */
.fctl-app .pf-v6-c-form-control > ::placeholder,
.fctl-app .pf-v6-c-text-input-group__text-input::placeholder {
  opacity: 0.6;
}

/*
 * PatternFly ExpandableSection animates collapse via max-height, which can leave
 * reserved vertical space when collapsed. Override when content is hidden.
 */
.fctl-app .pf-v6-c-expandable-section__content:where([hidden]) {
  --pf-v6-c-expandable-section__content--MaxHeight: 0;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/styles/global.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;;EAEE,YAAY;AACd;;AAEA;;;EAGE;AACF;EACE,mDAAmD;AACrD","sourcesContent":["/*\n * Reduce opacity of all placeholders so they are clearly distinguishable from entered values.\n */\n.fctl-app .pf-v6-c-form-control > ::placeholder,\n.fctl-app .pf-v6-c-text-input-group__text-input::placeholder {\n  opacity: 0.6;\n}\n\n/*\n * PatternFly ExpandableSection animates collapse via max-height, which can leave\n * reserved vertical space when collapsed. Override when content is hidden.\n */\n.fctl-app .pf-v6-c-expandable-section__content:where([hidden]) {\n  --pf-v6-c-expandable-section__content--MaxHeight: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
